// Функция для проверки, находимся ли мы на главной странице или на странице "О комплексе"
function isHomePage() {
  const path = window.location.pathname;
  return path === '/' || path === '/index.php' || path === '/o-komplekse/' || path === '/o-komplekse';
}

// Функция инициализации слайдера one-zoom
// Возвращает true, когда слайдер создан (или уже был), false — когда ещё рано.
function initOneZoomSlider() {
  const oneZoomSlider = document.querySelector('[data-swiper="one-zoom"]');
  if (!oneZoomSlider || typeof Swiper === 'undefined') {
    return false;
  }

  // Кнопки берём из самого слайдера и передаём в Swiper как DOM-элементы.
  // Строковые селекторы Swiper разворачивает через document.querySelectorAll,
  // и такой глобальный '.swiper-button-next' вешает click на кнопки ВСЕХ
  // слайдеров страницы, из-за чего стрелки работают не у того слайдера.
  const nextBtn = oneZoomSlider.querySelector('.swiper-button-next');
  const prevBtn = oneZoomSlider.querySelector('.swiper-button-prev');

  // Контейнер слайдера появляется в DOM раньше, чем отрисуются его слайды
  // и кнопки. Не отдаём navigation: undefined — модуль навигации Swiper читает
  // params.navigation.enabled без проверки и падает на undefined.
  if (!nextBtn || !prevBtn || !oneZoomSlider.querySelector('.swiper-slide')) {
    return false;
  }

  // Уже инициализирован — второй экземпляр не создаём.
  if (oneZoomSlider.swiper) {
    return true;
  }

  const isHeroMain = Boolean(oneZoomSlider.closest('.hero-main'));
  const paginationEl = oneZoomSlider.querySelector('.swiper-pagination');

  // Hero — всегда slide как на ПК. Остальные страницы — coverflow.
  const useCoverflow = !isHeroMain;

  new Swiper(oneZoomSlider, {
    speed: isHeroMain ? 650 : 1000,
    loop: true,
    slidesPerView: useCoverflow ? 'auto' : 1,
    spaceBetween: 0,
    initialSlide: useCoverflow ? 1 : 0,
    centeredSlides: useCoverflow,
    effect: useCoverflow ? 'coverflow' : 'slide',
    coverflowEffect: useCoverflow ? {
      scale: 0.95,
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: true,
    } : undefined,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    pagination: isHeroMain && paginationEl ? {
      el: paginationEl,
      clickable: true,
    } : undefined,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1
    },
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    on: {
      slideChange: function () {
        const videos = document.querySelectorAll('.video-player__video');
        videos.forEach(item => {
          if (item && item?.dataset?.src && !item?.src) {
            item.src = item.dataset.src;
          }
        });
      }
    }
  });

  return true;
}

function updateMainFeatureArrows(slider) {
  if (!slider) {
    return;
  }

  const activeSlide = slider.querySelector('.swiper-slide-active');
  if (!activeSlide) {
    return;
  }

  const activeWidth = activeSlide.getBoundingClientRect().width;
  slider.style.setProperty('--main-feature-active-width', `${activeWidth}px`);
}

function initMainFeatureSlider() {
  const slider = document.querySelector('[data-swiper="main-feature"]');
  if (!slider || typeof Swiper === 'undefined') {
    return false;
  }

  if (slider.swiper) {
    updateMainFeatureArrows(slider);
    return true;
  }

  const slidesCount = slider.querySelectorAll('.swiper-slide').length;
  if (!slidesCount) {
    return false;
  }

  const nextBtn = slider.querySelector('.swiper-button-next');
  const prevBtn = slider.querySelector('.swiper-button-prev');

  const swiperInstance = new Swiper(slider, {
    spaceBetween: 0,
    loop: slidesCount > 1,
    slidesPerView: 'auto',
    allowTouchMove: true,
    effect: 'coverflow',
    autoHeight: true,
    centeredSlides: true,
    initialSlide: slidesCount > 1 ? 1 : 0,
    coverflowEffect: {
      scale: 0.95,
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: true,
    },
    breakpoints: {
      768: {
        allowTouchMove: false,
      },
    },
    navigation: nextBtn && prevBtn ? {
      nextEl: nextBtn,
      prevEl: prevBtn,
    } : undefined,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
  });

  swiperInstance.on('init', () => updateMainFeatureArrows(slider));
  swiperInstance.on('slideChangeTransitionEnd', () => updateMainFeatureArrows(slider));
  swiperInstance.on('resize', () => updateMainFeatureArrows(slider));
  updateMainFeatureArrows(slider);

  if (!slider.dataset.mainFeatureArrowsReady) {
    slider.dataset.mainFeatureArrowsReady = '1';
    window.addEventListener('resize', () => updateMainFeatureArrows(slider));
  }

  return true;
}

// Инициализация one-zoom сразу, как только DOM с слайдером готов (не ждём modal/swiper модули).
function tryInitOneZoomSlider() {
  if (initOneZoomSlider()) {
    return;
  }

  // DOM уже полностью распарсен — слайдера на странице нет, ждать нечего
  if (document.readyState !== 'loading') {
    initOneZoomSlider();
    return;
  }

  let checkInterval = null;
  const stopWaiting = () => {
    observer.disconnect();
    if (checkInterval !== null) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
  };

  const observer = new MutationObserver(() => {
    if (initOneZoomSlider()) {
      stopWaiting();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  checkInterval = setInterval(() => {
    if (initOneZoomSlider()) {
      stopWaiting();
    }
  }, 16);

  // Конец парсинга DOM (= «футер дорисован») — финальная попытка и стоп
  document.addEventListener('DOMContentLoaded', () => {
    initOneZoomSlider();
    stopWaiting();
  }, { once: true });
}

tryInitOneZoomSlider();

// Сначала загружаем modal.js и swiper.js
Promise.all([
  import("../../components/modal/modal.js"),
  import("../../components/swiper/swiper.js")
]).then(() => {
  jQuery(document).ready(function ($) {
    const calcIpotekaImports = [
      import("../../../template-parts/section-calc-ipoteka/section-calc-ipoteka-additional.js"),
    ];

    if (document.getElementById('calc-ipoteka-classic')) {
      calcIpotekaImports.push(
        import("../../../template-parts/section-calc-ipoteka/section-calc-ipoteka.js")
      );
    }

    if (document.querySelector('.calc-ipoteka-variants-root')) {
      calcIpotekaImports.push(
        import("../../../template-parts/section-calc-ipoteka/section-calc-ipoteka-variants.js")
      );
    }

    Promise.all(calcIpotekaImports);

    // Загружаем все динамические модули параллельно
    Promise.all([
      import("../../components/form/form.js"),
      import("../../components/form/modal-callback-message.js"),
      import("../../components/form/privacy-check.js"),
      import("../../components/video/video.js"),
      import("../../../template-parts/section-main-map/section-main-map.js"),
    ]).then(([form, modalCallbackMessage, privacyCheck, video, mainMap]) => {
      // Инициализируем модули после загрузки
      if (form && typeof form.default === 'function') form.default($);
      if (modalCallbackMessage && typeof modalCallbackMessage.default === 'function') {
        modalCallbackMessage.default();
      }
      if (privacyCheck && typeof privacyCheck.default === 'function') privacyCheck.default($);
      if (video && typeof video.default === 'function') video.default($);
      if (mainMap && typeof mainMap.default === 'function') mainMap.default($);
    });
  });
  
  // Создаем массив всех промисов импорта
  Promise.all([
    // Статические импорты
    ...(!isHomePage() ? [
      import("../../components/vue/components/hover-slider.js"),
      import("../../components/vue/components/catalog-item.js"),
      import("../../components/vue/components/catalog-page.js"),
      import("../../components/vue/components/catalog-single.js"),
      import("../../components/vue/components/catalog-compare.js"),
      import("../vue-select.js"),
    ] : []),
    import("../../components/menu/menu.js"),
    import("../../components/accordion/accordion.js"),
    import("../../../template-parts/section-genplan/genplan.js"),
    import("../../components/platform/platform.min.js"),
  ]).then((modules) => {

    const paginatonSliderTop = function (sliderSelector) {
      const sliders = document.querySelectorAll(sliderSelector);
      sliders.forEach(function (slider) {
        const imageBox = slider.querySelector('.swiper-slide-active .photo img');
        const paginators = slider.querySelectorAll('.swiper-buttons-paginatons');
        const imageBoxHeight = imageBox ? imageBox.offsetHeight : 0;
        if (paginators.length > 0) {
          paginators.forEach(paginator => {
            paginator.style.top = `${imageBoxHeight / 2}px`;
          });
        } else {
          const paginatorsLeft = slider.querySelectorAll('.swiper-button-prev');
          const paginatorsRight = slider.querySelectorAll('.swiper-button-next');
          paginatorsLeft.forEach(leftBtn => {
            leftBtn.style.top = `${imageBoxHeight / 2}px`;
          });
          paginatorsRight.forEach(rightBtn => {
            rightBtn.style.top = `${imageBoxHeight / 2}px`;
          });
        }
      });
    }

    const isLaptop = window.matchMedia('(max-width: 1200px)').matches;
    const isLaptopMin = window.matchMedia('(max-width: 960px)').matches;
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    function whenDomReady(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function pollTabbedSliderInit(sectionSelector, initFn, options = {}) {
      const { intervalMs = 30, maxAttempts = 300 } = options;

      whenDomReady(() => {
        let attempts = 0;

        const tick = () => {
          attempts += 1;

          if (typeof Swiper === 'undefined') {
            return false;
          }

          const section = document.querySelector(sectionSelector);
          if (!section) {
            return true;
          }

          return Boolean(initFn(section));
        };

        if (tick()) {
          return;
        }

        const intervalId = setInterval(() => {
          if (tick() || attempts >= maxAttempts) {
            clearInterval(intervalId);
          }
        }, intervalMs);
      });
    }

    
    function initw3bedkj0nSlider() {
      if (document.querySelector('.slider-w3bedkj0n--type_large') && document.querySelector('.slider-w3bedkj0n--type_small') && document.querySelector('.slider-w3bedkj0n--type_text')) {
        const swiperLargew3bedkj0n = new Swiper('.slider-w3bedkj0n--type_large', {
          spaceBetween: `0`,
          navigation: {
            nextEl: '.slider-w3bedkj0n__button-next',
            prevEl: '.slider-w3bedkj0n__button-prev',
          },

          loop: true,
          slidesPerView: 'auto',
          effect: "coverflow",
          initialSlide: 0,
          coverflowEffect: {
            scale: 0.95,
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 1,
            slideShadows: true,
          },
          breakpoints: {
            1201: {
              allowTouchMove: false,
              spaceBetween: 30,
              initialSlide: 0,
            },
          },
          // Отключаем предзагрузку всех слайдов
          preloadImages: false,
          // Включаем ленивую загрузку
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1
          },
          // Уменьшаем количество одновременно загруженных слайдов
          watchSlidesProgress: true,
          // Оптимизация производительности
          observer: true,
          observeParents: true,
        });

        if (!isLaptop) {
          const swiperSmall = new Swiper('.slider-w3bedkj0n--type_small', {
            initialSlide: 1,
            spaceBetween: 30,
            loop: true,
            allowTouchMove: false,
            // speed: 1000,
            // Отключаем предзагрузку всех слайдов
            preloadImages: false,
            // Включаем ленивую загрузку
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            // Уменьшаем количество одновременно загруженных слайдов
            watchSlidesProgress: true,
            // Оптимизация производительности
            observer: true,
            observeParents: true,
          });
          swiperLargew3bedkj0n.on('navigationNext', () => {
            swiperSmall.slideNext();
          });

          swiperLargew3bedkj0n.on('navigationPrev', () => {
            swiperSmall.slidePrev();
          });
          // swiperLargew3bedkj0n.on('slideChange', () => {
          //   swiperSmall.slideTo(swiperLargew3bedkj0n.realIndex + 1);
          // });
        } else {
          if (document.querySelector('.slider-w3bedkj0n--type_small')) {
            document.querySelector('.slider-w3bedkj0n--type_small').remove();
          }
          paginatonSliderTop('.sliders-w3bedkj0n');
          window.addEventListener('resize', () => {
            paginatonSliderTop('.sliders-w3bedkj0n');
          });
        }
        const swiperSmall = new Swiper('.slider-w3bedkj0n--type_text', {
          initialSlide: 0,
          spaceBetween: 30,
          loop: true,
          allowTouchMove: false,
          effect: "fade",
          fadeEffect: {
            crossFade: true
          },
          // Отключаем предзагрузку всех слайдов
          preloadImages: false,
          // Включаем ленивую загрузку
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1
          },
          // Уменьшаем количество одновременно загруженных слайдов
          watchSlidesProgress: true,
          // Оптимизация производительности
          observer: true,
          observeParents: true,
          // speed: 1000,
        });
        // swiperLargew3bedkj0n.on('navigationNext', () => {
        //   swiperSmall.slideNext();
        // });

        // swiperLargew3bedkj0n.on('navigationPrev', () => {
        //   swiperSmall.slidePrev();
        // });
        swiperLargew3bedkj0n.on('slideChange', () => {
          swiperSmall.slideTo(swiperLargew3bedkj0n.realIndex);
        });
        return true;
      }
      return false;
    }

    function initVariantsHousesSlider() {
      const variantsHousesSlider = document.querySelector('.swiper-variants-houses');
      if (variantsHousesSlider && typeof Swiper !== 'undefined') {
        new Swiper(variantsHousesSlider, {
          speed: 300,
          loop: true,
          slidesPerView: 1,
          loopAddBlankSlides: true,
          spaceBetween: 0,
          centeredSlides: true,
          breakpoints: {
            961: {
              spaceBetween: 60,
              slidesPerView: 3,
            },
          },
          navigation: {
            nextEl: '.section-swiper-variants-houses .swiper-button-next',
            prevEl: '.section-swiper-variants-houses .swiper-button-prev',
          },
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1
          },
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
        });
        return true;
      }
      return false;
    }

    function initQuarterLayoutsSlider(section) {
      const sliders = section.querySelectorAll('.quarter-layouts-swiper');
      if (!sliders.length || typeof Swiper === 'undefined') {
        return false;
      }

      const swiperInstances = [];

      sliders.forEach((slider) => {
        const instance = new Swiper(slider, {
          // speed: 1000,
          loop: true,
          slidesPerView: 1,
          allowTouchMove: isMobile,
          centeredSlides: true,
          spaceBetween: 0,
          effect: "coverflow",
          coverflowEffect: {
            scale: 0.90,
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 1,
            slideShadows: true,
          },
          breakpoints: {
            961: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          },
          navigation: {
            nextEl: '.section-quarter-layouts .swiper-button-next',
            prevEl: '.section-quarter-layouts .swiper-button-prev',
          },
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1
          },
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
        });
        swiperInstances.push(instance);
      });

      function updateQuarterLayoutsArrows() {
        if (!section) return;

        const activeSlider = section.querySelector('.quarter-layouts-slider.active .quarter-layouts-swiper');
        if (!activeSlider) return;

        const activeSlide = activeSlider.querySelector('.swiper-slide-active');
        if (!activeSlide) return;

        const slideRect = activeSlide.getBoundingClientRect();
        const activeWidth = slideRect.width;

        section.style.setProperty('--quarter-layouts-active-width', `${activeWidth}px`);
      }

      swiperInstances.forEach((instance) => {
        instance.on('init', updateQuarterLayoutsArrows);
        // instance.on('slideChange', updateQuarterLayoutsArrows);
        instance.on('resize', updateQuarterLayoutsArrows);
      });

      const groups = section.querySelectorAll('.quarter-layouts-group');
      const sliderWrappers = section.querySelectorAll('.quarter-layouts-slider');
      const buttonWrappers = section.querySelectorAll('.quarter-layouts-btn');
      if (groups.length && sliderWrappers.length) {
        groups.forEach((group, index) => {
          group.addEventListener('click', () => {
            groups.forEach(g => g.classList.remove('active'));
            group.classList.add('active');
            sliderWrappers.forEach((wrapper, wrapperIndex) => {
              if (wrapperIndex === index) {
                wrapper.classList.add('active');
              } else {
                wrapper.classList.remove('active');
              }
            });
            if (buttonWrappers.length) {
              buttonWrappers.forEach((buttonWrapper, buttonIndex) => {
                if (buttonIndex === index) {
                  buttonWrapper.classList.add('active');
                } else {
                  buttonWrapper.classList.remove('active');
                }
              });
            }
            updateQuarterLayoutsArrows();
          });
        });
      }

      // Клик по слайду -> открываем галерею текущей группы без дублей
      section.querySelectorAll('.quarter-layouts-slide').forEach((slide) => {
        slide.addEventListener('click', (e) => {
          e.preventDefault();
          const galleryId = slide.dataset.galleryId;
          const index = parseInt(slide.dataset.galleryIndex, 10);
          if (!galleryId || isNaN(index)) return;

          const links = section.querySelectorAll(
            `a[data-fslightbox="${galleryId}"][data-gallery-index]`
          );
          if (!links.length || index < 0 || index >= links.length) return;

          const targetLink = links[index];
          if (typeof refreshFsLightbox === 'function') {
            refreshFsLightbox();
          }
          targetLink.click();
        });
      });

      updateQuarterLayoutsArrows();

      return true;
    }

    function initLandscapingSlider(section) {
      if (typeof Swiper === 'undefined') {
        return false;
      }

      const slidersWrap = section.querySelector('.landscaping-sliders');
      if (!slidersWrap) {
        return true;
      }

      const expectedCount = parseInt(slidersWrap.dataset.slidersCount || '0', 10);
      const sliders = Array.from(slidersWrap.querySelectorAll('.landscaping-swiper'));
      const sliderWrappers = slidersWrap.querySelectorAll('.landscaping-slider');
      const LANDSCAPING_AUTOPLAY_DELAY = 7500;

      if (!sliders.length) {
        return false;
      }

      if (expectedCount > 0 && sliders.length < expectedCount) {
        return false;
      }

      function getLandscapingOriginalCount(slider) {
        const fromData = parseInt(slider.dataset.originalSlides || '0', 10);
        if (fromData > 0) {
          return fromData;
        }
        return slider.querySelectorAll('.swiper-slide').length;
      }

      function getLandscapingLogicalIndex(swiper, originalCount) {
        if (!swiper || originalCount <= 0) {
          return 0;
        }
        return swiper.realIndex % originalCount;
      }

      function updateLandscapingBullets(slider, logicalIndex, progress = 0) {
        const bullets = slider.querySelectorAll('.landscaping-swiper-bullet');
        if (!bullets.length) {
          return;
        }

        const safeProgress = Math.max(0, Math.min(1, progress));

        bullets.forEach((bullet, index) => {
          const isActive = index === logicalIndex;
          const isPassed = index < logicalIndex;
          bullet.classList.toggle('is-active', isActive);
          bullet.classList.toggle('is-passed', isPassed);
          const progressEl = bullet.querySelector('.landscaping-swiper-bullet__progress');
          if (!progressEl) {
            return;
          }
          if (isPassed) {
            progressEl.style.width = '100%';
          } else if (isActive) {
            progressEl.style.width = `${safeProgress * 100}%`;
          } else {
            progressEl.style.width = '0%';
          }
        });
      }

      function getLandscapingSwiperOptions(slidesCount, originalCount, autoplayEnabled) {
        const useAutoplay = originalCount > 1;

        return {
          loop: slidesCount > 1,
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 0,
          allowTouchMove: isMobile,
          effect: 'coverflow',
          coverflowEffect: {
            scale: 0.95,
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 1,
            slideShadows: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 1,
              centeredSlides: false,
              effect: 'slide',
              coverflowEffect: {
                scale: 1,
                rotate: 0,
                stretch: 0,
                depth: 0,
                modifier: 1,
                slideShadows: false,
              },
            },
          },
          autoplay: useAutoplay
            ? {
                delay: LANDSCAPING_AUTOPLAY_DELAY,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                enabled: Boolean(autoplayEnabled),
              }
            : false,
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
        };
      }

      function getSliderByIndex(index) {
        return slidersWrap.querySelector(`.landscaping-slider[data-landscaping-slider="${index}"] .landscaping-swiper`)
          || sliders[index]
          || null;
      }

      function slideToLandscapingLogical(instance, originalCount, targetLogical) {
        if (!instance || originalCount <= 0) {
          return;
        }

        const safeTarget = ((targetLogical % originalCount) + originalCount) % originalCount;
        const currentLogical = getLandscapingLogicalIndex(instance, originalCount);
        if (safeTarget === currentLogical) {
          return;
        }

        if (instance.params.loop && typeof instance.slideToLoop === 'function') {
          instance.slideToLoop(safeTarget);
          return;
        }

        const slides = instance.slides || [];
        let targetSlideIndex = safeTarget;

        for (let i = 0; i < slides.length; i++) {
          const slide = slides[i];
          if (!slide || slide.classList.contains('swiper-slide-duplicate')) {
            continue;
          }
          const rawIndex = parseInt(slide.getAttribute('data-swiper-slide-index') || String(i), 10);
          if (rawIndex % originalCount === safeTarget) {
            targetSlideIndex = i;
            break;
          }
        }

        instance.slideTo(targetSlideIndex);
      }

      function bindLandscapingBullets(slider, instance, originalCount) {
        const pagination = slider.querySelector('.landscaping-swiper-pagination');
        const bullets = slider.querySelectorAll('.landscaping-swiper-bullet');
        if (!bullets.length || originalCount <= 1) {
          return;
        }

        if (pagination && pagination.dataset.bound !== '1') {
          pagination.dataset.bound = '1';
          pagination.addEventListener('click', (event) => {
            const bullet = event.target.closest('.landscaping-swiper-bullet');
            if (!bullet || !pagination.contains(bullet)) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();

            const targetIndex = parseInt(bullet.dataset.landscapingBullet || '0', 10);
            if (Number.isNaN(targetIndex)) {
              return;
            }

            const swiperInstance = slider.swiper || instance;
            if (!swiperInstance) {
              return;
            }

            slideToLandscapingLogical(swiperInstance, originalCount, targetIndex);

            if (swiperInstance.autoplay && typeof swiperInstance.autoplay.start === 'function') {
              swiperInstance.autoplay.start();
            }
          });
        }
      }

      function initSliderInstance(index, { autoplayEnabled = false } = {}) {
        const slider = getSliderByIndex(index);
        if (!slider) {
          return null;
        }

        const originalCount = getLandscapingOriginalCount(slider);

        if (slider.swiper) {
          bindLandscapingBullets(slider, slider.swiper, originalCount);
          if (slider.swiper.autoplay) {
            if (autoplayEnabled) {
              slider.swiper.autoplay.start();
            } else {
              slider.swiper.autoplay.stop();
            }
          }
          updateLandscapingBullets(
            slider,
            getLandscapingLogicalIndex(slider.swiper, originalCount),
            autoplayEnabled ? 0 : 0
          );
          return slider.swiper;
        }

        const slidesCount = slider.querySelectorAll('.swiper-slide').length;
        const instance = new Swiper(
          slider,
          getLandscapingSwiperOptions(slidesCount, originalCount, autoplayEnabled)
        );

        instance.on('slideChange', () => {
          updateLandscapingNavigation();
          updateLandscapingBullets(
            slider,
            getLandscapingLogicalIndex(instance, originalCount),
            0
          );
        });
        instance.on('resize', updateLandscapingNavigation);
        instance.on('autoplayTimeLeft', (_swiper, _timeLeft, percentage) => {
          const wrapper = slider.closest('.landscaping-slider');
          if (!wrapper || !wrapper.classList.contains('active')) {
            return;
          }
          updateLandscapingBullets(
            slider,
            getLandscapingLogicalIndex(instance, originalCount),
            1 - percentage
          );
        });

        bindLandscapingBullets(slider, instance, originalCount);
        updateLandscapingBullets(slider, getLandscapingLogicalIndex(instance, originalCount), 0);

        return instance;
      }

      function refreshLandscapingSwiper(index) {
        sliderWrappers.forEach((wrapper, wrapperIndex) => {
          const slider = getSliderByIndex(wrapperIndex);
          if (!slider || !slider.swiper || !slider.swiper.autoplay) {
            return;
          }
          if (wrapperIndex === index) {
            slider.swiper.autoplay.start();
          } else {
            slider.swiper.autoplay.stop();
          }
        });

        const swiper = initSliderInstance(index, { autoplayEnabled: true });
        if (!swiper) {
          return;
        }

        requestAnimationFrame(() => {
          swiper.update();
          swiper.updateSlidesClasses();
          swiper.updateProgress();
          updateLandscapingNavigation();
          const slider = getSliderByIndex(index);
          if (slider) {
            updateLandscapingBullets(
              slider,
              getLandscapingLogicalIndex(swiper, getLandscapingOriginalCount(slider)),
              0
            );
          }
        });
      }

      function getActiveSwiperIndex() {
        return Array.from(sliderWrappers).findIndex((wrapper) => wrapper.classList.contains('active'));
      }

      function getActiveSwiper() {
        const index = getActiveSwiperIndex();
        if (index < 0) {
          return null;
        }

        return initSliderInstance(index, { autoplayEnabled: true });
      }

      function updateLandscapingNavigation() {
        const activeSwiper = getActiveSwiper();
        if (!activeSwiper || !prevBtn || !nextBtn) return;

        prevBtn.classList.toggle('swiper-button-disabled', activeSwiper.isBeginning && !activeSwiper.params.loop);
        nextBtn.classList.toggle('swiper-button-disabled', activeSwiper.isEnd && !activeSwiper.params.loop);
      }

      const prevBtn = section.querySelector('.swiper-button-prev');
      const nextBtn = section.querySelector('.swiper-button-next');

      const activeIndex = Math.max(0, getActiveSwiperIndex());

      sliders.forEach((slider, index) => {
        if (!slider.swiper) {
          initSliderInstance(index, { autoplayEnabled: index === activeIndex });
        }
      });

      if (section.dataset.landscapingReady !== '1') {
        section.dataset.landscapingReady = '1';

        if (prevBtn && nextBtn) {
          prevBtn.addEventListener('click', () => {
            const activeSwiper = getActiveSwiper();
            if (activeSwiper) {
              activeSwiper.slidePrev();
            }
          });

          nextBtn.addEventListener('click', () => {
            const activeSwiper = getActiveSwiper();
            if (activeSwiper) {
              activeSwiper.slideNext();
            }
          });
        }

        const tabs = section.querySelectorAll('.landscaping-tabs-item');

        if (tabs.length && sliderWrappers.length) {
          tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
              tabs.forEach((item) => item.classList.remove('active'));
              tab.classList.add('active');

              sliderWrappers.forEach((wrapper, wrapperIndex) => {
                wrapper.classList.toggle('active', wrapperIndex === index);
              });

              refreshLandscapingSwiper(index);
            });
          });
        }
      }

      updateLandscapingNavigation();

      return sliders.length >= expectedCount && sliders.every((slider) => Boolean(slider.swiper));
    }

    function initFinishingSlider(section) {
      if (typeof Swiper === 'undefined') {
        return false;
      }

      const slidersWrap = section.querySelector('.finishing-slider-sliders');
      if (!slidersWrap) {
        return true;
      }

      const expectedCount = parseInt(slidersWrap.dataset.slidersCount || '0', 10);
      const sliders = Array.from(slidersWrap.querySelectorAll('.finishing-swiper'));
      const sliderWrappers = slidersWrap.querySelectorAll('.finishing-slider');

      if (!sliders.length) {
        return false;
      }

      if (expectedCount > 0 && sliders.length < expectedCount) {
        return false;
      }

      const prevBtn = section.querySelector('.finishing-slider-nav .swiper-button-prev');
      const nextBtn = section.querySelector('.finishing-slider-nav .swiper-button-next');
      const paginationsEl = section.querySelector('.finishing-slider-nav .swiper-buttons-paginatons');

      function getFinishingSwiperOptions(slidesCount) {
        const useLoop = slidesCount > 1;

        return {
          loop: useLoop,
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 15,
          initialSlide: 0,
          breakpoints: {
            768: {
              loop: false,
              slidesPerView: 2.15,
              centeredSlides: false,
              spaceBetween: 24,
            },
            1201: {
              loop: false,
              slidesPerView: 3,
              centeredSlides: false,
              spaceBetween: 24,
            },
          },
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
        };
      }

      function getSliderByIndex(index) {
        return slidersWrap.querySelector(`.finishing-slider[data-finishing-slider="${index}"] .finishing-swiper`)
          || sliders[index]
          || null;
      }

      function initSliderInstance(index) {
        const slider = getSliderByIndex(index);
        if (!slider) {
          return null;
        }

        if (slider.swiper) {
          return slider.swiper;
        }

        const slidesCount = slider.querySelectorAll('.swiper-slide').length;

        return new Swiper(slider, getFinishingSwiperOptions(slidesCount));
      }

      function refreshFinishingSwiper(index) {
        const swiper = initSliderInstance(index);
        if (!swiper) {
          return;
        }

        requestAnimationFrame(() => {
          swiper.updateSize();
          swiper.update();
          swiper.updateSlidesClasses();
        });
      }

      function getActiveSwiperIndex() {
        return Array.from(sliderWrappers).findIndex((wrapper) => wrapper.classList.contains('active'));
      }

      function getActiveSwiper() {
        const index = getActiveSwiperIndex();
        if (index < 0) {
          return null;
        }

        return initSliderInstance(index);
      }

      function updateFinishingNavigation() {
        const activeSwiper = getActiveSwiper();
        if (!activeSwiper || !prevBtn || !nextBtn) {
          return;
        }

        const isPrevDisabled = activeSwiper.isBeginning;
        const isNextDisabled = activeSwiper.isEnd;

        prevBtn.classList.toggle('swiper-button-disabled', isPrevDisabled);
        nextBtn.classList.toggle('swiper-button-disabled', isNextDisabled);

        if (paginationsEl) {
          paginationsEl.classList.toggle('is-hidden', isPrevDisabled && isNextDisabled);
        }
      }

      sliders.forEach((slider, index) => {
        if (!slider.swiper) {
          const instance = initSliderInstance(index);
          if (instance) {
            instance.on('slideChange', updateFinishingNavigation);
            instance.on('resize', updateFinishingNavigation);
          }
        }
      });

      if (section.dataset.finishingSliderReady !== '1') {
        section.dataset.finishingSliderReady = '1';

        if (prevBtn && nextBtn) {
          prevBtn.addEventListener('click', () => {
            const activeSwiper = getActiveSwiper();
            if (activeSwiper) {
              activeSwiper.slidePrev();
            }
          });

          nextBtn.addEventListener('click', () => {
            const activeSwiper = getActiveSwiper();
            if (activeSwiper) {
              activeSwiper.slideNext();
            }
          });
        }

        const tabs = section.querySelectorAll('.finishing-slider-tabs-item');

        if (tabs.length && sliderWrappers.length) {
          tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
              tabs.forEach((item) => item.classList.remove('active'));
              tab.classList.add('active');

              sliderWrappers.forEach((wrapper, wrapperIndex) => {
                wrapper.classList.toggle('active', wrapperIndex === index);
              });

              refreshFinishingSwiper(index);
              updateFinishingNavigation();
            });
          });
        }
      }

      updateFinishingNavigation();

      return sliders.length >= expectedCount && sliders.every((slider) => Boolean(slider.swiper));
    }

    function initGallerySlider() {
      const section = document.querySelector('.section-gallery-slider');
      if (!section || typeof Swiper === 'undefined') {
        return false;
      }

      const slider = section.querySelector('.gallery-swiper');
      if (!slider) {
        return false;
      }

      if (slider.swiper) {
        return true;
      }

      const slidesCount = slider.querySelectorAll('.swiper-slide').length;
      const expectedCount = parseInt(slider.dataset.slidesCount || '0', 10);

      if (!slidesCount) {
        return false;
      }

      if (expectedCount > 0 && slidesCount < expectedCount) {
        return false;
      }

      const prevBtn = section.querySelector('.gallery-slider-wrap .swiper-button-prev');
      const nextBtn = section.querySelector('.gallery-slider-wrap .swiper-button-next');

      const instance = new Swiper(slider, {
        spaceBetween: 0,
        loop: slidesCount > 1,
        slidesPerView: 'auto',
        allowTouchMove: isMobile,
        effect: 'coverflow',
        autoHeight: true,
        centeredSlides: true,
        initialSlide: slidesCount > 1 ? 1 : 0,
        coverflowEffect: {
          scale: 0.95,
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: true,
        },
        breakpoints: {
          768: {
            allowTouchMove: false,
          },
        },
        navigation: prevBtn && nextBtn ? {
          nextEl: nextBtn,
          prevEl: prevBtn,
        } : undefined,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
      });

      return slidesCount >= expectedCount;
    }

    if (!isHomePage()) {
      // Функция инициализации Vue компонентов без зависимости от порядка modules
      function initVueComponents() {
        // Инициализируем страницу каталога, если присутствует
        if (document.querySelector("#catalog")) {
          import("../../components/vue/components/catalog-page.js").then((m) => {
            if (m && m.default) m.default();
          });
        }

        // Инициализируем catalog-single и catalog-compare
        const initSingles = () => {
          import("../../components/vue/components/catalog-single.js").then((m) => {
            if (m && m.default) m.default();
          });
          import("../../components/vue/components/catalog-compare.js").then((m) => {
            if (m && m.default) m.default();
          });
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initSingles);
        } else {
          initSingles();
        }
      }

      // Проверяем состояние загрузки документа
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVueComponents);
      } else {
        initVueComponents();
      }

    }
    // Создаем интервал для проверки каждые 30мс
    // const checkInterval = setInterval(() => {
    //   if (initOneZoomSlider()) {
    //     clearInterval(checkInterval); // Останавливаем интервал если инициализация прошла успешно
    //   }
    // }, 30);
    // Создаем интервал для проверки каждые 30мс
    const check3bedkj0Interval = setInterval(() => {
      if (initw3bedkj0nSlider()) {
        clearInterval(check3bedkj0Interval); // Останавливаем интервал если инициализация прошла успешно
      }
    }, 30);

    const checkVariantsHousesInterval = setInterval(() => {
      if (initVariantsHousesSlider()) {
        clearInterval(checkVariantsHousesInterval); // Останавливаем интервал если инициализация прошла успешно
      }
    }, 30);

    pollTabbedSliderInit('.section-quarter-layouts', initQuarterLayoutsSlider);
    pollTabbedSliderInit('.section-landscaping', initLandscapingSlider);
    pollTabbedSliderInit('.section-finishing-slider', initFinishingSlider);

    const checkMainFeatureInterval = setInterval(() => {
      if (initMainFeatureSlider()) {
        clearInterval(checkMainFeatureInterval);
      }
    }, 30);

    const checkGallerySliderInterval = setInterval(() => {
      if (initGallerySlider()) {
        clearInterval(checkGallerySliderInterval);
      }
    }, 30);

    import("../../../template-parts/section-quarter-apartment-picker/section-quarter-apartment-picker.js").then((module) => {
      if (module?.default) {
        whenDomReady(module.default);
      }
    });

    
    // Функция инициализации таймера
    function initTimer() {
      const $timer = document.querySelector(".timer");
      if ($timer) {
        const $days = document.querySelector(".timer__days");
        const $hours = document.querySelector(".timer__hours");
        const $minutes = document.querySelector(".timer__minutes");
        const $seconds = document.querySelector(".timer__seconds");
        const timerDateRaw = $timer.getAttribute("data-timer");
        if (!timerDateRaw) {
          return false;
        }
        const initialDeadline = new Date(timerDateRaw);
        if (isNaN(initialDeadline.getTime())) {
          return false;
        }
        const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

        // Склонение числительных
        function declensionNum(num, words) {
          return words[
            num % 100 > 4 && num % 100 < 20
              ? 2
              : [2, 0, 1, 1, 1, 2][num % 10 < 5 ? num % 10 : 5]
          ];
        }

        // Всегда берем ближайшую дату цикла (+7 дней от исходной даты)
        function getCurrentCycleDeadline(now) {
          const elapsed = now.getTime() - initialDeadline.getTime();
          if (elapsed < 0) {
            return initialDeadline;
          }

          const passedCycles = Math.floor(elapsed / WEEK_MS);
          return new Date(initialDeadline.getTime() + (passedCycles + 1) * WEEK_MS);
        }

        // Вычисляем разницу дат и устанавливаем оставшееся времени
        function countdownTimer() {
          const now = new Date();
          const deadline = getCurrentCycleDeadline(now);
          const diff = deadline - now;

          const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
          const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
          const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
          const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;

          if ($days) $days.textContent = days < 10 ? "0" + days : days;
          if ($hours) $hours.textContent = hours < 10 ? "0" + hours : hours;
          if ($minutes) $minutes.textContent = minutes < 10 ? "0" + minutes : minutes;
          if ($seconds) $seconds.textContent = seconds < 10 ? "0" + seconds : seconds;

          if ($days) $days.dataset.title = declensionNum(days, ["день", "дня", "дней"]);
          if ($hours) $hours.dataset.title = declensionNum(hours, ["час", "часа", "часов"]);
          if ($minutes) $minutes.dataset.title = declensionNum(minutes, ["минута", "минуты", "минут"]);
          if ($seconds) $seconds.dataset.title = declensionNum(seconds, ["секунда", "секунды", "секунд"]);
        }

        // Запускаем таймер
        countdownTimer();
        const timerId = setInterval(countdownTimer, 1000);
        return true;
      }
      return false;
    }

    // Таймер живёт только на главной (page-template-front-page, front-page.php:9),
    // поэтому опрос запускаем только там.
    // И НЕ гасим интервал, пока блок .timer не появился: раньше проверка
    // "нет .timer → clearInterval" срабатывала на первом же тике, пока блок
    // ещё не отрисовался, и таймер не запускался никогда.
    if (isHomePage()) {
      // Бандл грузится в <head> — ждём DOM, иначе #cfp-app ещё нет.
      whenDomReady(() => {
        if (!document.querySelector('#cfp-app')) return;
        import("../../components/vue/components/catalog-filters-preview.js")
          .then((m) => {
            if (m && typeof m.default === 'function') m.default();
          })
          .catch((err) => {
            console.error('catalog-filters-preview init failed:', err);
          });
      });

      const timerCheckInterval = setInterval(() => {
        if (initTimer()) {
          clearInterval(timerCheckInterval);
        }
      }, 30);
    }

    // Динамические импорты в jQuery ready
    jQuery(document).ready(function ($) {
      // Проверяем, есть ли блок not-supported (он отображается только для неподдерживаемых браузеров)
      const notSupportedElement = document.querySelector(".not-supported");
      if (notSupportedElement) {
        // Если блок есть, значит браузер неподдерживаемый - активируем его
        notSupportedElement.classList.add("active");
        // Блокируем скролл страницы
        document.documentElement.style.overflow = "hidden";
        
        // Получаем информацию о браузере для отображения
        const browserName = platform.name;
        const browserVersion = platform.version;
        console.log('Неподдерживаемый браузер:', browserName, browserVersion);
        
        // Добавляем информацию о браузере в блок
        const browserInfo = document.createElement("div");
        browserInfo.textContent = `${browserName} ${browserVersion}`;
        // notSupportedElement.appendChild(browserInfo);
      }
      // const cardItems = document.querySelectorAll('.card-item');

      // function updateCardTags() {
      //   cardItems.forEach((cardItem) => {
      //     const cardTags = cardItem.querySelector('.card-tags');
      //     if (cardTags) {
      //       const cardTagsChildren = cardTags.children;
      //       const cardItemWidth = cardItem.offsetWidth;
      //       const maxTagsWidth = cardItemWidth - 125; // ширина в которую могет влезть в блок

      //       let totalWidth = 0;
      //       let hiddenCount = 0;

      //       Array.prototype.forEach.call(cardTagsChildren, (tag, index) => {
      //         if (index === cardTagsChildren.length - 1 && !tag.classList.contains('show-more')) {
      //           // последний элемент без класса show-more
      //           tag.classList.add('hidden');
      //         } else if (index < cardTagsChildren.length - 1) {
      //           totalWidth += tag.offsetWidth;
      //           if (totalWidth > maxTagsWidth) {
      //             tag.classList.add('hidden');
      //             hiddenCount++;
      //           } else {
      //             tag.classList.remove('hidden');
      //           }
      //         }
      //       });

      //       const showMoreButton = cardTags.querySelector('.show-more');
      //       if (showMoreButton) {
      //         showMoreButton.textContent = `+${hiddenCount}`;
      //       } else if (hiddenCount > 0) {
      //         cardTags.insertAdjacentHTML('beforeend', `<span class="card-tag show-more">+${hiddenCount}</span>`);
      //       }
      //     }
      //   });

      //   const showMoreButtons = document.querySelectorAll('.show-more');
      //   if (showMoreButtons.length) {
      //     showMoreButtons.forEach((button) => {
      //       button.addEventListener('click', (event) => {
      //         event.preventDefault(); // предотвратить переход по ссылке
      //         const cardTags = button.parentNode;
      //         const hiddenTags = cardTags.querySelectorAll('.card-tag.hidden');
      //         hiddenTags.forEach((tag) => {
      //           tag.classList.remove('hidden');
      //         });
      //         button.remove(); // удалить кнопку "Show more"
      //       });
      //     });
      //   }
      // }

      // updateCardTags();
      $(".phonemask").mask("+7 (999) 999-99-99");
      $(".wpcf7-validates-as-tel").mask("+7 (999) 999-99-99")
        .on('focus', function(){
          $(this).val('+7 (');

          var self = this;

          setTimeout(() => {
              self.setSelectionRange(4, 4);
          }, 100);
      })
      .on('focusout', function(){
          if ($(this).val().length <= 4) {
              $(this).val('');
          }
          
          // Проверяем валидность через maskedinput
          if ($(this).val().length === 18 && $(this).val().indexOf('_') === -1) { // Проверяем что нет незаполненных символов маски
              // Если маска заполнена полностью, удаляем класс wpcf7-not-valid
              $(this).removeClass('wpcf7-not-valid');
              // Удаляем следующий элемент span.wpcf7-not-valid-tip
              $(this).next('span.wpcf7-not-valid-tip').remove();
          } else {
            $(this).addClass('wpcf7-not-valid');
            // Добавляем подсказку, если её нет
            if ($(this).next('.wpcf7-not-valid-tip').length === 0) {
                $(this).after('<span class="wpcf7-not-valid-tip">Это обязательное поле.</span>');
            }
          }
      })
      .on('keyup', function(){
          if ($(this).val().length === 5) {
              if ($(this).val().charAt($(this).val().length - 1) === '8') {
                  $(this).val('+7 (');
              }
          }
      });

      $('.wpcf7-text[name="your-name"]').on('input', function() {
          $(this).val($(this).val().replace(/[0-9]/g, ''));
      });

      // $('.wpcf7-form-control[type="email"]').on('focusout', function() {
      //     const email = $(this).val();
      //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          
      //     if (!emailRegex.test(email)) {
      //         $(this).val('');
      //     }
      // });
      $(".numbermask").mask("9?9");
      $(".datemask").mask("99.99.9999");
      $(".media-tabs").tabs();
      // $(".nav-genplan-bottom").tabs();

      if (document.querySelector(".fancybox-construction")) {
        document
          .querySelectorAll(".fancybox-construction")
          .forEach((el) => {
            const rawImages = el.getAttribute("data-images");
            if (!rawImages) {
              return;
            }

            const images = rawImages
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
            if (!images.length) {
              return;
            }

            // На данный момент thumb = src (если в будущем появятся отдельные thumbs — можно расширить).
            const thumbs = images.slice();

            el.addEventListener("click", () => {
              Fancybox.show(
                images.map((image, index) => ({
                  src: image,
                  thumb: thumbs[index],
                }))
              );
            });
          });
      }
      // плавная прокрутка

      const cardItemsHover = document.querySelectorAll(
        ".card-item.card-text-hover"
      );
      if (cardItemsHover) {
        // На touch-устройствах `mouseover` может срабатывать при тапе.
        // Поэтому не навешиваем hover-анимацию для карточек.
        let isHoverDisabledByMedia = false;
        try {
          // Проверяем "мобильную" ширину в пикселях (как в других местах проекта).
          const mq = window.matchMedia && window.matchMedia("(max-width: 767px)");
          isHoverDisabledByMedia = !!(mq && mq.matches);
        } catch (e) {
          isHoverDisabledByMedia = false;
        }

        if (!isHoverDisabledByMedia) {
          cardItemsHover.forEach((cardItem) => {
            cardItem.addEventListener("mouseover", () => {
              const cardText = cardItem.querySelector(".card-wrapper-text");
              if (!cardText) return;
              const height = cardText.scrollHeight;
              cardText.style.height = "0px";
              cardText.style.height = `${height}px`;
            });

            cardItem.addEventListener("mouseout", () => {
              const cardText = cardItem.querySelector(".card-wrapper-text");
              if (!cardText) return;
              cardText.style.height = "0px";
            });
          });
        }
      }

      // Neighborhoods cards: tags overflow (+x) + mobile expand stats
      (function initNeighborhoodsCards() {
        const cards = document.querySelectorAll(".neighborhoods-card");
        if (!cards.length) return;

        const getTagsLimit = () =>
          window.matchMedia("(max-width: 767px)").matches ? 2 : 3;

        const applyTagsLimit = (card) => {
          const tagsRoot = card.querySelector("[data-tags]");
          if (!tagsRoot) return;

          const tags = Array.from(tagsRoot.querySelectorAll("[data-tag]"));
          const moreBtn = tagsRoot.querySelector("[data-tags-more]");
          if (!tags.length || !moreBtn) return;

          const limit = getTagsLimit();
          const expanded = tagsRoot.classList.contains("is-expanded");

          tags.forEach((tag, index) => {
            tag.classList.toggle("is-hidden", !expanded && index >= limit);
          });

          const hiddenCount = Math.max(0, tags.length - limit);
          if (!expanded && hiddenCount > 0) {
            moreBtn.hidden = false;
            moreBtn.textContent = `+${hiddenCount}`;
            moreBtn.setAttribute("aria-expanded", "false");
          } else {
            moreBtn.hidden = true;
            moreBtn.textContent = "";
            moreBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
          }
        };

        cards.forEach((card) => {
          applyTagsLimit(card);

          const moreBtn = card.querySelector("[data-tags-more]");
          if (moreBtn) {
            moreBtn.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              const tagsRoot = card.querySelector("[data-tags]");
              if (!tagsRoot) return;
              tagsRoot.classList.add("is-expanded");
              applyTagsLimit(card);
            });
          }

          // Mobile: tap по карточке — комнатности выезжают снизу (кнопки всегда видны)
          if (card.hasAttribute("data-has-stats")) {
            card.addEventListener("click", (e) => {
              if (!window.matchMedia("(max-width: 767px)").matches) return;
              if (e.target.closest("a, button")) return;
              card.classList.toggle("is-expanded");
            });
          }
        });

        let resizeTimer;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            cards.forEach((card) => {
              const tagsRoot = card.querySelector("[data-tags]");
              if (tagsRoot) tagsRoot.classList.remove("is-expanded");
              if (!window.matchMedia("(max-width: 767px)").matches) {
                card.classList.remove("is-expanded");
              }
              applyTagsLimit(card);
            });
          }, 150);
        });
      })();

      // loadmore js

      let mediaPhoto = document.querySelector(".media-block-photo");
      let mediaItemPhoto = document.querySelectorAll(".media-block-photo .photo");
      let mediaVideo = document.querySelector(".media-block-video");
      let mediaItemVideo = document.querySelectorAll(
        ".media-block-video .video-player"
      );

      let photoVisibleItems = 10;
      let videoVisibleItems = 10;
      function setItemsToShow(pc, mobile) {
        var windowWidth = window.innerWidth;
        return windowWidth >= 960 ? pc : mobile;
      }

      function showItems(items, show) {
        for (var i = 0; i < show; i++) {
          if (items[i]) {
            items[i].classList.add("show");
          }
        }
      }

      function hideLoadMoreButton(parrent, items, show) {
        if (show >= items.length) {
          parrent.querySelector(".loadmore").style.display = "none";
        }
      }

      if (mediaPhoto) {
        let loadMoreButtonPhoto = mediaPhoto.querySelector(".loadmore");

        photoVisibleItems = setItemsToShow(10, 10);
        showItems(mediaItemPhoto, photoVisibleItems);
        hideLoadMoreButton(mediaPhoto, mediaItemPhoto, photoVisibleItems);

        loadMoreButtonPhoto.addEventListener("click", function () {
          photoVisibleItems += setItemsToShow(10, 10);
          showItems(mediaItemPhoto, photoVisibleItems);
          hideLoadMoreButton(mediaPhoto, mediaItemPhoto, photoVisibleItems);
        });

        window.addEventListener(
          "resize",
          function () {
            photoVisibleItems = setItemsToShow(10, 10);
            showItems(mediaItemPhoto, photoVisibleItems);
            hideLoadMoreButton(mediaPhoto, mediaItemPhoto, photoVisibleItems);
          },
          { passive: true }
        );
      }
      if (mediaVideo) {
        let loadMoreButtonVideo = mediaVideo.querySelector(".loadmore");
        videoVisibleItems = setItemsToShow(10, 10);
        showItems(mediaItemVideo, videoVisibleItems);
        hideLoadMoreButton(mediaVideo, mediaItemVideo, videoVisibleItems);

        loadMoreButtonVideo.addEventListener("click", function () {
          videoVisibleItems += setItemsToShow(10, 10);
          showItems(mediaItemVideo, videoVisibleItems);
          hideLoadMoreButton(mediaVideo, mediaItemVideo, videoVisibleItems);
        });

        window.addEventListener(
          "resize",
          function () {
            videoVisibleItems = setItemsToShow(10, 10);
            showItems(mediaItemVideo, videoVisibleItems);
            hideLoadMoreButton(mediaVideo, mediaItemVideo, videoVisibleItems);
          },
          { passive: true }
        );
      }

      // Группы городов
      // createMap(ИД КАРТЫ ДОЛЖЕН БЫТЬ map_город, ГОРОД где )
      if (document.querySelector("#map")) {
        createMap(map);
      }

      //  НЕ ТРОГАТЬ НИЖЕ
      function createMap(cityMap) {
        ymaps.ready(init);
        function init() {
          // Создание экземпляра карты.
          var myMap = new ymaps.Map(cityMap, {
            center: object.center,
            zoom: 14,
          });
          myMap.behaviors.disable("scrollZoom");
          createMenuGroup(object);
          function createMenuGroup(group) {
            let collection = new ymaps.GeoObjectCollection(null);
            if (group.items.length > 0) {
              group.items.forEach(function (item, index) {
                let placemark = new ymaps.Placemark(
                  item.center,
                  {
                    balloonContentBody: `
                    <div class="ymaps-balloon-wrapper">
                      <h3 class="ymaps-balloon-heading">
                        ${item.content}
                      </h3>
                    </div>
                  `,
                  },
                  {
                    iconLayout: "default#image",
                    iconImageHref: item.img,
                    iconImageSize: item.size,
                    hideIconOnBalloonOpen: false,
                    balloonOffset: [20, -26],
                  }
                );
                collection.add(placemark);
              });
              myMap.geoObjects.add(collection);
            }
          }
        }
      }

      function isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      }

      if (isSafari()) {
        document.querySelectorAll(".bcg-gradient").forEach((el) => el.remove());
      }

      // Функция обновления счетчика сравнения
      function updateCompareCount() {
        const compareItems = JSON.parse(localStorage.getItem('compareItems') || '[]');
        const compareCount = document.querySelector('.icon-header-compare-count');
        
        if (compareCount) {
          compareCount.textContent = compareItems.length;
          compareCount.style.display = compareItems.length > 0 ? 'flex' : 'none';
        }
      }

      // Функция для перемещения попапа в body
      function moveComparePopupToBody() {
        const comparePopup = document.querySelector('.compare-popup');
        const compareIcon = document.querySelector('.icon-header.icon-compare');
        
        if (comparePopup && compareIcon) {
          // Перемещаем попап в body если он еще не там
          if (comparePopup.parentElement !== document.body) {
            document.body.appendChild(comparePopup);
            
            // Обновляем стили для абсолютного позиционирования
            comparePopup.style.position = 'fixed';
            comparePopup.style.zIndex = '99999';
            
            // Функция обновления позиции
            function updatePopupPosition() {
              const iconRect = compareIcon.getBoundingClientRect();
              comparePopup.style.top = `${iconRect.bottom + 15}px`;
              comparePopup.style.left = `${iconRect.right - comparePopup.offsetWidth}px`;
            }
            
            // Обновляем позицию при скролле и ресайзе
            window.addEventListener('scroll', updatePopupPosition);
            window.addEventListener('resize', updatePopupPosition);
            
            // Обновляем позицию сразу
            updatePopupPosition();
          }
        }
      }

      // Создаем функцию для обновления localStorage с событием
      function updateLocalStorage(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
        // Создаем и диспатчим кастомное событие
        window.dispatchEvent(new CustomEvent('localStorageChange', {
          detail: { key, value }
        }));
      }

      // Обновляем счетчик при загрузке страницы
      updateCompareCount();
      moveComparePopupToBody();

      // Слушаем изменения в localStorage (для изменений из других вкладок)
      window.addEventListener('storage', function(e) {
        if (e.key === 'compareItems') {
          updateCompareCount();
        }
      });

      // Слушаем кастомное событие (для изменений в текущей вкладке)
      window.addEventListener('localStorageChange', function(e) {
        if (e.detail.key === 'compareItems') {
          updateCompareCount();
        }
      });

      // Делаем функцию доступной глобально
      window.updateLocalStorage = updateLocalStorage;

      $(".compare-popup-close").on("click", function() {
        $(".compare-popup").removeClass("active");
      });

      // window.realtor_objects = [
      //   { id: 1, title: 'Квартира в ЖК "Солнечный"' },
      //   { id: 2, title: 'Квартира в ЖК "Морской"' }
      // ];
      const $select = $('.page-realtor .section-form-photo-bcg #custom-object-select');
      if ($select.length && Array.isArray(window.realtor_objects) && window.realtor_objects.length) {
        $select
          .empty()
          .select2({
            data: window.realtor_objects.map(obj => ({
              id: obj.id,
              text: obj.title
            })),
            allowClear: false,
            minimumResultsForSearch: Infinity
          })
          .val(window.realtor_objects[0].id)
          .trigger('change');

        const $hiddenInput = document.querySelector('.page-realtor .section-form-photo-bcg #cf7-object-field');
        if ($hiddenInput) {
          $hiddenInput.value = window.realtor_objects[0].id;
          $select.on('change', function () {
            const val = $(this).val();
            if (Array.isArray(val)) {
              $hiddenInput.value = val.join(', ');
            } else {
              $hiddenInput.value = val || '';
            }
          });
        }
      }
    });
    // плавная прокрутка
    jQuery(document).ready(function ($) {
      const anchors = document.querySelectorAll('a[href*="#"]');
      anchors.forEach(function (anchor) {
        anchor.addEventListener("click", function (event) {
          if (event.defaultPrevented) {
            return;
          }

          const rawHref = (event.currentTarget.getAttribute("href") || "").trim();
          if (rawHref === "" || rawHref === "#") {
            return;
          }

          const href = rawHref.replace(/.*#/, "");
          const modal = document.querySelector(`.modal[data-modal-id='${href}']`);
          const tabsMenu = document.querySelector(
            `.menu-blog .ui-tabs-tab[aria-controls='${href}']`
          );
          const tabsAccordion = document.querySelector(
            `.accordion-item.ui-tabs-tab[aria-controls='${href}']`
          );
          if (!modal && !tabsMenu && !tabsAccordion) {
            const target = document.querySelector(anchor.hash);
            if (target) {
              event.preventDefault();
              scrollToCustom(anchor.hash, 300);
            }
          }
          if (tabsMenu) {
            tabs.querySelector("a").click();
            event.preventDefault();
          }
        });
      });

      $("html, body").on(
        "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove",
        function () {
          $(this).stop();
        }
      );
    });
    jQuery(function ($) {
      window.scrollToCustom = function (blockName, animSpeed) {
        if ($(blockName)) {
          var offsTop = $(blockName).offset().top;
          clickScrollStat = true;
          $("body").off("mousewheel");
          $("body").on("mousewheel", function () {
            $("html, body").stop();
          });
          if (offsTop != $(window).scrollTop()) {
            $("html, body")
              .stop()
              .animate(
                { scrollTop: offsTop - $("header").height() },
                animSpeed,
                "easeInOutQuart",
                function () {
                  $("body").off("mousewheel");
                  clickScrollStat = false;
                  history.pushState(null, null, location.href.split("#")[0]);
                }
              );
          } else $("body").off("mousewheel");
        }
      };
    });
  }).catch(error => {
    console.error('Ошибка при загрузке статических модулей:', error);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const video = document.querySelectorAll('.video-player__video');
  video.forEach(item => {
    if (item && item?.dataset?.src && !item?.src) {
      item.src = item.dataset.src;
    }
  });
  (function() {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice) return;
  
    const sliders = document.querySelectorAll('.footer-row-quarter');
  
    sliders.forEach(slider => {
      let isDown = false;
      let startX;
      let scrollLeft;
      let isDragging = false; // флаг, чтобы понять, был ли свайп
  
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        isDragging = false;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.style.cursor = 'grabbing';
      });
  
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.style.cursor = 'grab';
      });
  
      slider.addEventListener('mouseup', () => {
        isDown = false;
        setTimeout(() => (isDragging = false), 0); // сбрасываем чуть позже
        slider.style.cursor = 'grab';
      });
  
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1;
        if (Math.abs(walk) > 5) isDragging = true; // если движение больше 5px — считаем свайпом
        slider.scrollLeft = scrollLeft - walk;
      });
  
      // предотвращаем открытие ссылки после свайпа
      slider.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
  
      slider.style.cursor = 'grab';
      slider.style.userSelect = 'none';
    });
  })();
});



let hoverLockInitialized = false;

const removeHoverStyles = () => {
  if (hoverLockInitialized) return;
  hoverLockInitialized = true;

  // Убираем :hover правила на мобильной ширине (в пикселях).
  const mediaQuery = window.matchMedia('(max-width: 767px)');
  if (!mediaQuery.matches) return;

  const stripHoverRules = () => {
    Array.from(document.styleSheets).forEach((sheet) => {
      try {
        const rules = sheet.cssRules;
        if (!rules) return;

        for (let i = rules.length - 1; i >= 0; i--) {
          const rule = rules[i];
          if (
            rule.type === CSSRule.STYLE_RULE &&
            'selectorText' in rule &&
            typeof rule.selectorText === 'string'
          ) {
            const selectors = rule.selectorText
              .split(',')
              .map((selector) => selector.trim())
              .filter(Boolean);

            const hoverSelectors = selectors.filter((selector) =>
              selector.includes(':hover')
            );

            if (!hoverSelectors.length) continue;

            const nonHoverSelectors = selectors.filter(
              (selector) => !selector.includes(':hover')
            );

            const cssText = rule.style.cssText;
            sheet.deleteRule(i);

            if (nonHoverSelectors.length) {
              const newRule = `${nonHoverSelectors.join(', ')} { ${cssText} }`;
              sheet.insertRule(newRule, i);
            }
          }
        }
      } catch (error) {
        // Игнорируем стили с ограничениями доступа (например, из других доменов)
      }
    });
  };

  stripHoverRules();

  const observer = new MutationObserver(() => stripHoverRules());
  observer.observe(document.head, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', removeHoverStyles, { once: true });
} else {
  removeHoverStyles();
}